// extracted by mini-css-extract-plugin
export default {"signupForm":"SignupForm_signupForm__8GCCz","sumbitButton":"SignupForm_sumbitButton__Csn+m"};